export enum URLS_API {
  CHECK_LOG_IN = '/bff-vle/checkLogin',
  LOGOUT = '/bff-vle/logout',
  RESEND_EMAIL = '/bff-vle/users/welcomeEmail',
}
